import { format } from 'date-fns'
import {
  AcompanhamentoUltimosContatosQuery,
  DadosUltimosContatosQuery,
  OrigemDadoEnum,
  TipoAtendimentoProfissional,
  TipoRegistroHistoricoClinico,
} from 'graphql/types.generated'
import { turnoRecord } from 'types/enums'
import {
  recordCuidadoCompartilhadoPrioridadeTagStyle,
  recordEscutaHistoricoTagStyle,
  SubtipoAtendimentoTag,
  subtipoRecord,
  tipoRegistroHistoricoData,
} from 'view/atendimentos/detail/historico/model/model-historico'
import { convertCiap, convertCid10 } from 'view/atendimentos/detail/utils-cuidadoCompartilhado'
import { LabelPrioridadeCuidadoCompartilhadoDwRecord } from 'view/cuidados-compartilhados/model-cuidadoCompartilhado'

import { FolhaRostoUltimosContatosModel } from './model'

export type DadosUltimosContatosModel = DadosUltimosContatosQuery['historico']['content'][number]
export type AcompanhamentoUltimosContatosModel = AcompanhamentoUltimosContatosQuery['historico']['content'][number]

export function convertContatoToModel(contato: DadosUltimosContatosModel): FolhaRostoUltimosContatosModel {
  const tipoAtendimentoEnum = contato.tipoApresentacao ?? contato.tipoAtendProf
  const historicoDataRecord = tipoRegistroHistoricoData[tipoAtendimentoEnum.toString()]
  const escutaInicialTagEnabled =
    (contato.tipoAtendProf === TipoAtendimentoProfissional.ESCUTA_INICIAL ||
      contato.tipoApresentacao === TipoRegistroHistoricoClinico.ESCUTA_INICIAL) &&
    !!contato.classificacaoRisco
  const isConsumoAlimentar = tipoAtendimentoEnum === TipoRegistroHistoricoClinico.CONSUMO_ALIMENTAR
  const isCuidadoCompartilhado = tipoAtendimentoEnum === TipoRegistroHistoricoClinico.CUIDADO_COMPARTILHADO
  const prioridadeCuidadoCompartilhado =
    contato.cuidadoCompartilhadoEvolucao?.classificacaoPrioridade ??
    LabelPrioridadeCuidadoCompartilhadoDwRecord[contato.classificacaoPrioridade]

  return {
    id: contato.codigoUnicoRegistro,
    tipo: contato.tipoApresentacao,
    title: historicoDataRecord.descricao,
    barColor: historicoDataRecord.barColor,
    icon: historicoDataRecord.icon,
    color: historicoDataRecord.iconColor,
    dataOrTurno:
      contato.origemAtendimento === OrigemDadoEnum.PEC &&
      contato.tipoApresentacao !== TipoRegistroHistoricoClinico.ATIVIDADE_COLETIVA
        ? format(contato.dataAtendimento, "dd/MM/yyyy 'às' HH:mm")
        : `${format(contato.dataAtendimento, 'dd/MM/yyyy')} ${contato.turno ? `- ${turnoRecord[contato.turno]}` : ''}`,
    headerTags: !isConsumoAlimentar ? convertTag(historicoDataRecord.tags, contato.coSubtipoAtendimento) : null,
    classificacaoRisco: escutaInicialTagEnabled
      ? recordEscutaHistoricoTagStyle[contato.classificacaoRisco]
      : isCuidadoCompartilhado
      ? recordCuidadoCompartilhadoPrioridadeTagStyle[prioridadeCuidadoCompartilhado]
      : null,
    idadeGestacional:
      contato.tipoApresentacao === TipoRegistroHistoricoClinico.PRE_NATAL ||
      contato.tipoAtendProf === TipoAtendimentoProfissional.PRE_NATAL
        ? contato.idadeGestacional
        : null,
    contentTags: isConsumoAlimentar ? convertTag(historicoDataRecord.tags, contato.coSubtipoAtendimento) : null,
    dadosClinicos: contato.dadosClinicos,
    examesRealizadosZika: contato.examesRealizadosZika.length > 0 ? contato.examesRealizadosZika : null,
    historicoAtendimento: contato,
    hasObservacao: contato.hasObservacao,
    isCuidadoCompartilhado: isCuidadoCompartilhado,
    cid10: convertCid10(contato),
    ciap: convertCiap(contato),
  }
}

export function convertTag(tags: SubtipoAtendimentoTag[], subtipoAtendimento: ID) {
  return tags
    ?.filter((tag: SubtipoAtendimentoTag) => tag.id === subtipoAtendimento)
    .map((tag: SubtipoAtendimentoTag) => ({
      label: subtipoRecord[tag.nome],
      color: tag.tagColor,
    }))
}
